import { Component } from '@angular/core';
import { Events, IonicPage, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

import { AuthProvider } from '../../providers/auth/auth';
import { OrderProvider } from "../../providers/order/order";
import { PosmCategoryProvider } from "../../providers/posm-category/posm-category";
import { PosmCategory } from "../../models/posm-category.model";


import { PosmItemsPage } from '../posm-items/posm-items';
import { PosmSubitemsPage } from '../posm-subitems/posm-subitems';
import { LoginPage } from '../auth/login';

import { fadeInOutAnimation } from '../../animations/fade-in-out';
import { listAnimation } from '../../animations/list-animation';

import { BasketPage } from "../basket/basket";
import { OrdersListPage } from "../orders-list/orders-list";

import { Storage } from '@ionic/storage';
@IonicPage()
@Component({
  selector: 'page-posm-categories',
  templateUrl: 'posm-categories.html',
  animations: [
    fadeInOutAnimation,
    listAnimation
  ]
})
export class PosmCategoriesPage extends BasketPage {
  public posmCategories: PosmCategory[];
  public loading: boolean;

  public orderList: OrdersListPage;

  constructor(public storage: Storage, public events: Events, public orderProvider: OrderProvider, public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public translate: TranslateService, private posmCategoryProvider: PosmCategoryProvider, public modalCtrl: ModalController, public authProvider: AuthProvider) {
    super(storage, events, orderProvider, navCtrl, navParams, viewCtrl, translate, modalCtrl, authProvider);

    this.orderList = new OrdersListPage(storage, events, orderProvider, navCtrl, navParams, viewCtrl, translate, modalCtrl);
  }

  getPosmCategories() {
    this.loading = true;
    this.posmCategoryProvider.getAll()
      .subscribe(
        posmCategories => this.posmCategories = posmCategories,
        error => {
          if (error.status == 401) {
            this.disconnected();
          }
          this.loading = false;
        },
        () => {
          this.events.publish('orderList:get_data');
          this.events.publish('basket:refresh');
          this.loading = false;
        }
      );
  }

  reloadPosmCategories(refresher) {
    this.getPosmCategories();
    refresher.complete();
  }

  selectChildsByCategory(posmCategory: PosmCategory) {

    if (posmCategory.link_to === "POSM_SUBITEMS") {
      this.navCtrl.push(PosmSubitemsPage, {
        parentID: posmCategory.id,
        parentName: posmCategory.translation || posmCategory.name,
        parentTitle: posmCategory.title || posmCategory.translation || posmCategory.name,
        parentContent: posmCategory.content || "",
        parentType: "POSM_CATEGORY"
      });
    } else if(posmCategory.link_to === "POSM_ITEMS") {
      this.navCtrl.push(PosmItemsPage, {
        posmCategoryId: posmCategory.id,
        posmCategoryName: posmCategory.translation || posmCategory.name,
        posmCategoryTitle: posmCategory.title || posmCategory.translation || posmCategory.name,
        posmCategoryContent: posmCategory.content || ""
      });
    }
  }

  disconnected() {
    this.navCtrl.setRoot(LoginPage, {
      disconnected: true
    });
  }

  ionViewDidLoad() {
    this.getPosmCategories();
  }

}



// WEBPACK FOOTER //
// ./src/pages/posm-categories/posm-categories.ts